module.exports = {"150925103":"鸿茅镇","150925104":"六苏木镇","150925105":"麦胡图镇","150925106":"永兴镇","150925107":"蛮汉镇","150925108":"岱海镇","150925218":"天成乡","150925220":"曹碾满族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150925.json
// module id = 559
// module chunks = 0